import VueRouter from "vue-router";
import EncounterIndex from "@/services/EncounterIndex";
import { userModule } from "@/store/modules/user";
import { PEMANTAUAN_GIZI_TAB } from "@/utils/ralanFormRegistry";
import { isPemeriksaanRingkas, pemeriksaanRouteName } from "@/utils/unit";
import type { UmurPasien } from "@/types/orderGizi";

export interface TujuanPemeriksaanGizi {
  register_id: string;
  rm: string;
  unit_id?: string | null;
}

export async function bukaPemeriksaanGizi(
  router: VueRouter,
  pasien: TujuanPemeriksaanGizi,
  pemantauan = false
): Promise<void> {
  const params = {
    register: String(pasien.register_id),
    rm: String(pasien.rm)
  };

  if (isPemeriksaanRingkas(userModule.user?.unit_id)) {
    const query: Record<string, string> = pemantauan
      ? { topTab: "tab-assesmen", tab: PEMANTAUAN_GIZI_TAB }
      : {};
    await router
      .push({ name: "pemeriksaan", params, query })
      .catch(() => undefined);
    return;
  }

  const name = pemeriksaanRouteName(pasien.unit_id);
  let query: Record<string, string> = {};

  if (name === "pemeriksaan-ranap") {
    await EncounterIndex.regRanap(params.register, params.rm).catch(
      () => undefined
    );
    if (pemantauan) {
      query = {
        topTab: "tab-rekam-medis",
        tab: PEMANTAUAN_GIZI_TAB,
        category: "Keperawatan dan Monitoring"
      };
    }
  }

  await router.push({ name, params, query }).catch(() => undefined);
}

export function bukaRiwayatPasien(router: VueRouter, rm: string): void {
  router
    .push({ name: "detail-pasien", params: { rm: String(rm) } })
    .catch(() => undefined);
}

export function formatUmur(umur: UmurPasien | string | null | undefined): string {
  if (!umur) return "";
  if (typeof umur === "string") return umur;

  if (umur.th > 0) return `${umur.th} th`;
  if (umur.bln > 0) return `${umur.bln} bln`;
  return `${umur.hr} hr`;
}
